import React from 'react';
import { Col, DatePicker, Row } from 'antd';
import moment from 'moment';
const { MonthPicker } = DatePicker; 

export default class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                    <MonthPicker
                            placeholder="Filtrar por fecha inicio"
                            format="MM/YYYY"
                            clearIcon={false}
                            value={moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(_, formatDate) => this.props.onChange('fechaInicioStr', '01/' + formatDate)}
                            size="middle"
                            className='min-width-135'
                        />
                    </Col>
            {/*         <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col> */}
                </Row>
            </div>
        );
    }
}